export enum RollupType {
    Local = "LOCAL",
    Server = "SERVER",
}

export enum RollupSnapshotStatus {
    Created = "CREATED",
    Failed = "FAILED",
    Finished = "FINISHED",
    DeadlineExceeded = "DEADLINE_EXCEEDED",
    Canceled = "CANCELED",
    Stale = "STALE",
    Expired = "EXPIRED",
}

export interface ICreateRollupSnapshotRequest {
    merchantId: string;
    parentId: string;
    collectionIds: string[];
    name: string;
    rollupFolder?: nuorder.folder.v1.Item;
}

export interface ICollectionRef {
    item_id: string;
    collection_id: string;
    collection_trashed_status: boolean;
}
export interface IRollupSnapshotResponse {
    id: string;
    name: string;
    item_id: string;
    merchant_id: string;
    progress: number;
    progress_description?: string;
    progress_label?: string;
    status: RollupSnapshotStatus;
    error_text: string;
    collection_refs?: ICollectionRef[];
}
